module.exports = __webpack_public_path__ + "img/desktop.145f9c29.png";